import * as React from "react";
import Lottie from "react-lottie";
import animationData from "../lotties/videoloader";

export default function LoaderVideo() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <>
      <div className="loader-video">
        <Lottie options={defaultOptions} height={400} width={400} />
      </div>
    </>
  );
}
